import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const PaperPlates = () => <ProductDetailPage {...getProductPageConfig('paperPlates')} />;

export default PaperPlates;
